import { useGetAllBlogs } from '../functions/blogHook';
import { BlogCard } from '../components/BlogCard';
import {  Star } from 'lucide-react';

// Skeleton Loader mejorado
const SkeletonCard = () => (
  <div className="animate-pulse mb-12 bg-white rounded-2xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-[1.02]">
    <div className="h-48 bg-gradient-to-r from-gray-100 to-gray-200" />
    <div className="p-6 space-y-3">
      <div className="h-5 bg-gray-200 rounded-full w-3/4" />
      <div className="h-4 bg-gray-200 rounded-full w-full" />
      <div className="h-4 bg-gray-200 rounded-full w-5/6" />
      <div className="flex items-center justify-between">
        <div className="h-3 bg-gray-200 rounded-full w-20" />
        <div className="h-3 bg-gray-200 rounded-full w-16" />
      </div>
    </div>
  </div>
);

export const FeaturedBlogs = () => {
  const { blogs, isLoading, isError, error } = useGetAllBlogs();

  // Filtrar posts destacados
  const featuredPosts = blogs?.blogs?.filter(post => post.featured) || [];

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {Array(3).fill(0).map((_, index) => <SkeletonCard key={index} />)}
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center p-8 bg-red-50 rounded-xl">
        <p className="text-red-600 font-medium">⚠️ Error loading articles: {error?.message}</p>
      </div>
    );
  }

  if (!featuredPosts.length) {
    return (
      <div className="text-center p-8 bg-blue-50 rounded-xl">
        <p className="text-gray-600">🌟 No featured articles available</p>
      </div>
    );
  }

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-4 bg-indigo-100 px-6 py-2 rounded-full">
            <Star className="w-6 h-6 text-indigo-600" />
            <h2 className="text-2xl md:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600">
              Featured Articles
            </h2>
          </div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Discover our handpicked selection of premium content
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredPosts.map((post) => (
            <div key={post._id} className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity" />
              
              <BlogCard
                post={{
                  id: post._id,
                  title: post.title.length > 50 
                    ? `${post.title.substring(0, 50)}...` 
                    : post.title,
                  excerpt: post.excerpt.length > 120 
                    ? `${post.excerpt.substring(0, 120)}...` 
                    : post.excerpt,
                  readTime: `${post.readTime} min read`,
                  tag: post.tags[0] || "Premium",
                  image: post.images[0] || "/default-image.jpg",
                  featured: true // Añadir prop featured
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};